import { render, staticRenderFns } from "./lazy-background.vue?vue&type=template&id=c532e6be&scoped=true&"
import script from "./lazy-background.vue?vue&type=script&lang=js&"
export * from "./lazy-background.vue?vue&type=script&lang=js&"
import style0 from "./lazy-background.vue?vue&type=style&index=0&id=c532e6be&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c532e6be",
  null
  
)

export default component.exports